export default function faq() {
   const faqs = [...document.querySelectorAll(".js-faq")]
   faqs.forEach(faq => {
      faq.addEventListener("click", () => {
         faq.classList.toggle("open")
      })
   })
}